import React from 'react';
import {InputSignal} from '../bulk-override';
import {useTenantConfiguration} from '../hooks/use-tenant-configuration';
import {Notification} from '../navigation/page-layout';
import {OteExclusionManager} from '../ote-exclusions';

export function InputSignalsPage(props: {pushNotification: (notification: Notification) => void}) {
    const {configurationData, isLoading} = useTenantConfiguration();

    // Wait for config so the OTE exclusion column doesn't pop in after first render.
    if (isLoading) {
        return <React.Fragment></React.Fragment>;
    }

    const oteAnomalyDetectionEnabled = configurationData?.oteAnomalyDetectionEnabled ?? false;

    // Pass the exclusion controls in as an extra template column so they line up with Percentage
    // Adjustment instead of being stacked underneath it.
    const additionalTemplateSections = oteAnomalyDetectionEnabled
        ? [<OteExclusionManager key="ote-exclusions" pushNotification={props.pushNotification} />]
        : [];

    return (
        <InputSignal
            pushNotification={props.pushNotification}
            additionalTemplateSections={additionalTemplateSections}
            configurationData={configurationData}
        />
    );
}
